export default {
    management: 1,
    alerts: 2,
}